import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Badge } from 'antd'
import { useHistory } from 'react-router-dom'

import Routing, { MenuItem, SideMenu } from '../../components/reusable/routing'

import { useInventory, usePet, useReports, useShift, useSocketEvents, useLatestPathname } from '../../modules'

import Patients from './Patients'

const storeName = "Front Desk"

let menu = [
    {
        path: 'patients',
        title: 'Patients'
    },
    {
        path: 'appointments',
        title: 'Appointments'
    },
    {
        path: 'inventory',
        title: 'Inventory'
    },
    {
        path: 'reports',
        title: 'Reports'
    }
]

const department = "OPD"

const FrontDesk = () => {
    const [pendingCount, setPCount] = useState(0)

    useShift(department)

    const history = useHistory()
    const { user } = useSelector(state => state.application)
    const pathname = useLatestPathname()

    const [Inventory, store, requests] = useInventory(storeName)

    // const [, getPending] = usePet('pendingBillsCount', null, { notify: false, callback: ({ data }) => setPCount(data) })

    const [Reports, reports] = useReports("front-desk")

    // useSocketEvents({
    //     'new-bill': {
    //         condition: data => true,
    //         notif: {
    //             message: 'New Patient Bill',
    //             type: 'info'
    //         },
    //         callback: () => null //getPending
    //     }
    // })

    useEffect(() => {
        menu[0].component = props => <Patients path={ props?.path } />

        if (user.stores.some(st => st.name === storeName) || user?.issuperuser)
            menu[2] = {
                path: 'inventory',
                title: props => 
                    <Badge className='w-12' count={ requests }>
                        <MenuItem condition={ props?.condition }>Inventory</MenuItem>
                    </Badge>,
                component: ({ path }) => <Inventory requireShift department={ department } path={ path } storeName={ storeName } />
            }

        menu[3] = {
            path: 'reports',
            title: 'Reports',
            component: () => <Reports reports={ reports } department="front-desk" />
        }

        const target = `/app/front-desk/${menu[0].path}`
        if (!pathname.current.startsWith(target)) history.push(target)
    }, [store, user, reports])

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto flex flex-no-wrap max-h-full overflow-hidden">
            <div className="w-1/6 overflow-y-scroll">
                <p className="text-2xl font-semibold">Front Desk</p>
                <SideMenu namespace="front-desk" menu={ menu } />
            </div>
            <div className="w-5/6 overflow-y-scroll">
                <Routing namespace="front-desk" menu={ menu } />
            </div>
        </div>
    )
}

export default FrontDesk